export const INDEX_SLIDE = 'INDEX_SLIDE';
export const SECOND_TITLE = 'SECOND_TITLE';
export const FIRST_TITLE = 'FIRST_TITLE';
export const TOUCH_START = 'TOUCH_START'
export const TOUCH_MOVE = 'TOUCH_MOVE'


// WEBPACK FOOTER //
// ./src/vuex/actionType/state-type.js